export function enableEmailInvitations(): boolean {
  try {
    return __ENABLE_EMAIL_INVITATIONS__;
  } catch (err) {
    return false;
  }
}
